import { Helmet } from 'react-helmet-async';
import {
  DEFAULT_OG_IMAGE,
  absoluteUrl,
  absoluteImageUrl,
} from '../config/seo';
import { SITE_NAME } from '../config/site';

/**
 * @param {{
 *   title: string;
 *   description: string;
 *   path?: string;
 *   image?: string;
 *   robots?: string;
 *   jsonLd?: object | object[];
 * }} props
 */
export default function SeoHead({
  title,
  description,
  path,
  image,
  robots,
  jsonLd,
}) {
  const canonical = path != null ? absoluteUrl(path) : undefined;
  const ogImage = absoluteImageUrl(image) || DEFAULT_OG_IMAGE;
  const schemas = jsonLd
    ? Array.isArray(jsonLd)
      ? jsonLd.filter(Boolean)
      : [jsonLd]
    : [];

  return (
    <Helmet>
      <html lang="tr" />
      <title>{title}</title>
      <meta name="description" content={description} />
      {robots ? <meta name="robots" content={robots} /> : null}
      {canonical ? <link rel="canonical" href={canonical} /> : null}

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      {canonical ? <meta property="og:url" content={canonical} /> : null}
      <meta property="og:locale" content="tr_TR" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      {schemas.map((schema, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
}
